import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loaderActions } from '../../../_actions/loader.actions';
import { ClearLocalStorage } from '../../../components/commonClass/Session';
import { verifytoken } from '../../../services/ApiCallingUserServices';
import BookingTabs from '../partial/BookingTabs';
import { bookingDataResponse, getmoallbookingbystatusid } from '../partial/bookingUtils';


const HotelBookings = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const TravelCategoryId = 5;

    const [BookingList, setBookingList] = useState<bookingDataResponse[]>([]);
    const [filteritems, setFilterItems] = useState<bookingDataResponse[]>([]);

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState<any>('All');
    const [serchdisable, setSerachDisable] = useState(false);

    const [activeTab, setActiveTab] = useState(() => {
        const storedValue = localStorage.getItem("tab-hotel");
        return storedValue ? Number(storedValue) : 2;
    });

    const user = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const [userRights, setUserRights] = useState({ UserAdd: true, UserEdit: true, UserExport: true });

    useEffect(() => {
        //check for rights
        if (user) {
            const hasRights = user?.filter((fil: any) => fil?.PageLink?.toLowerCase() === window?.location?.pathname?.toLowerCase())
            if (hasRights?.length > 0) {
                hasRights?.forEach((obj: any) => {
                    setUserRights({ UserAdd: obj?.URightAdd, UserEdit: obj?.URightEdit, UserExport: obj?.URightExport })
                    if (!obj?.URightView) {
                        navigate('/dashboard');
                    }
                });
            }
        }
    }, [user])

    //#region Call API on tab change
    const getbookingdatalist = async () => {
        const moallbookingbystatusid = await getmoallbookingbystatusid(TravelCategoryId, activeTab);
        setBookingList(moallbookingbystatusid);
        setFilterItems(moallbookingbystatusid);
    }

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start())
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                setSearchValue("")
                setSerachBy("All")
                getbookingdatalist();
                dispatch(loaderActions.end())
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, [activeTab])
    //#endregion


    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'> {menuItem?.[0]?.pageTitle} {menuItem?.[1]?.pageTitle ? `(${menuItem?.[1]?.pageTitle})` : ""} </h2>
            </div>

            <BookingTabs
                TravelCategoryId={TravelCategoryId}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                BookingList={BookingList}
                setBookingList={setBookingList}
                filteritems={filteritems}
                userRights={userRights}
                searchvalue={searchvalue}
                setSearchValue={setSearchValue}
                searchby={searchby}
                setSerachBy={setSerachBy}
                serchdisable={serchdisable}
                getbookingdatalist={getbookingdatalist}
            />
        </>
    )
}

export default HotelBookings
